import { useRef, useState, useEffect } from 'react';
const INTERVAL_MS = 1000;

const useTimer = (durationMs, deps = []) => {
  const intervalRef = useRef(null);
  const [timer, setTimer] = useState(null);

  useEffect(() => {
    if (!durationMs) return;

    const endTimestamp = Date.now() + durationMs;
    const performUpdate = () => {
      const exp = endTimestamp - Date.now();

      if (exp <= 0) {
        setTimer(null);
        return clearInterval(intervalRef.current);
      }
      setTimer(exp);
    };

    performUpdate();

    intervalRef.current = setInterval(performUpdate, INTERVAL_MS);

    return () => clearInterval(intervalRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [durationMs, ...deps]);

  return timer;
};

export default useTimer;
